import React from 'react';
import { Select } from 'antd';
const CustomSelectBox = ({ ...props }) => {
  return (
    <Select
      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
      {...props}
    />
  );
};

export default CustomSelectBox;
